export default __webpack_public_path__ + "static/media/7minfitness_10@3x.0153a741.jpg";